// extracted by mini-css-extract-plugin
export default {"container":"Sq-z","heading":"Tq-z","text":"Uq-z","info":"Vq-z","link":"Wq-z","fullMaxWidth":"Xq-z"};